
<template>
    <div class="center">
        <vs-dialog v-model="active" prevent-close @close="closeModal">
            <template #header>
                <h4 class="not-margin">
                    CAMBIAR ESTATUS
                </h4>
            </template>
            <div class="con-form">
            <form autocomplete="off" @submit.prevent="postBajasSuspenciones()">
                <vs-row style="align-items: flex-end !important;">
                    <vs-col sm="12" lg="6" class="my-2">
                        <vs-select filter :loading="loadingInstituto" label="Institución" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col sm="12" lg="6" class="my-2">
                        <vs-select filter label="Ciclo escolar" :loading="loadingCiclo" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length">
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <vs-input
                            type="date"
                            v-model="fecha"
                            label="Fecha"
                        >
                            <template #message-danger v-if="errorFields.includes('fecha')">
                                Requerido
                            </template>
                        </vs-input>
                    </vs-col>
                    <vs-col sm="12" lg="6">
                        <vs-select 
                            filter 
                            label="Motivo"
                            class="pt-0"
                            placeholder="Motivo"
                            :key="estatuId" 
                            v-model="estatu"
                        >
                            <vs-option
                                v-for="option in estatus" 
                                :key="option.id"
                                :label="option.text"
                                :value="option.id"
                            >
                                {{option.text}}
                            </vs-option>
                            <template #message-danger v-if="errorFields.includes('estatu')">
                                Requerido
                            </template>
                        </vs-select>
                    </vs-col>
                    <vs-col sm="12" lg="8" class="my-2" v-if="([11, 12]).includes(estatu)">
                        <label class="mb-2" style="font-size: 0.75rem; padding-left: 11px;">Bloqueo de boleta por</label>
                        <div class="d-flex justify-content-around align-items-center">
                            <div :class="bloqueo_boleta_por == 'no_bloquear_boleta' ? 'motivoClass' : ''">
                                <vs-radio success v-model="bloqueo_boleta_por" val="no_bloquear_boleta">
                                    No bloquear boleta
                                </vs-radio>
                            </div>
                            <div :class="bloqueo_boleta_por == 'cartera_vencida' ? 'motivoClass' : ''">
                                <vs-radio success v-model="bloqueo_boleta_por" val="cartera_vencida">
                                    Cartera vencida
                                </vs-radio>
                            </div>
                            <div :class="bloqueo_boleta_por == 'conceptos_vencidos' ? 'motivoClass' : ''">
                                <vs-radio success v-model="bloqueo_boleta_por" val="conceptos_vencidos">
                                    Conceptos vencidos
                                </vs-radio>
                            </div>
                        </div>
                        <div  v-if="errorFields.includes('bloqueo_boleta_por')" class="vs-input__message vs-input__message--danger v-enter-to" style="height: 21px;">
                            Requerido
                        </div>
                    </vs-col>
                    <vs-col sm="12" lg="4" class="my-2">
                        <div class="d-flex align-items-center" v-if="(bloqueo_boleta_por && bloqueo_boleta_por != 'no_bloquear_boleta') && ([11, 12]).includes(estatu)">
                            <h5 class="mb-0" v-if="bloqueo_boleta_por == 'cartera_vencida'">$</h5>
                            <vs-input class="pb-0" v-model="cantidad_motivo" placeholder="Cantidad" type="number">
                            <template #message-danger v-if="errorFields.includes('cantidad_motivo')">
                                Requerido
                            </template>
                            </vs-input>
                        </div>
                    </vs-col>
                    <vs-col w="12" class="mt-3 mb-2" v-if="([11, 12]).includes(estatu)">
                        <div class="d-flex">
                            <label class="mb-2" style="font-size: 0.75rem; padding-left: 11px;">Cancelar cargos en tiempo</label>
                            <vs-tooltip>
                                <i class="fas fa-exclamation-circle ml-1"></i>
                                <template #tooltip>
                                    Si selecciona la opción <strong>"Cancelar los cargos"</strong>, esta confirmado que todos los cargos por cobrar que esten en tiempo se cancelaran para evitar tener cartera vencida. De lo contrario si quiere mantenerlos seleccione <strong>"Mantener cargos"</strong>
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="d-flex align-items-center">
                            <div :class="congelar_cargos_en_tiempo == 'mantener' ? 'motivoClass' : ''">
                                <vs-radio success v-model="congelar_cargos_en_tiempo" val="mantener">
                                    Mantener cargos
                                </vs-radio>
                            </div>
                            <div :class="congelar_cargos_en_tiempo == 'cancelar' ? 'motivoClass' : ''">
                                <vs-radio success v-model="congelar_cargos_en_tiempo" val="cancelar">
                                    Cancelar cargos
                                </vs-radio>
                            </div>
                        </div>
                        <div  v-if="errorFields.includes('congelar_cargos_en_tiempo')" class="vs-input__message vs-input__message--danger v-enter-to" style="height: 21px;">
                            Requerido
                        </div>
                        <p v-if="congelar_cargos_en_tiempo == 'cancelar'" style="color: red;">Esta confirmado que todos los cargos por cobrar que esten en tiempo se cancelaran para evitar tener cartera vencida.</p>
                    </vs-col>
                    <vs-col w="12" >
                        <label>Comentario</label>
                        <md-field :class="messageClass">
                            <label>Comentario</label>
                            <md-textarea v-model="comentario"></md-textarea>
                        </md-field>
                    </vs-col>
                </vs-row>
                <div class="d-flex mt-4">
                    <div @click="closeModal(), active = false">
                        <div class="botonCancelar">
                            Cancelar
                        </div>
                    </div>
                    <vs-button
                        success
                        type="submit"
                        class="ml-auto"
                    >
                        Guardar
                    </vs-button>
                </div>
            </form>
        </div>
      </vs-dialog>
    </div>
</template>
<script>
import alumno from '../../../../../api/requests/alumno'
export default {
    props:[
        'value',
        'personaRol',
        'general'
    ],
    data:() => ({
        active: false,
        institucion:'',
        instituciones: [],
        institucionId: (new Date()).getTime(),
        loadingInstituto: false,
        cicloEscolar: '',
        ciclosEscolares: [],
        cicloId: (new Date()).getTime(),
        loadingCiclo: false,
        fecha: '',
        estatu:'',
        estatus: [
            // {'id': 1, 'text': 'Prospecto'},
            // {'id': 2, 'text': 'Interesado'},
            // {'id': 3, 'text': 'Aplicante'},
            // {'id': 4, 'text': 'Admitido'},
            // {'id': 5, 'text': 'Inscrito económico'},
            // {'id': 6, 'text': 'Congelado'},
            // {'id': 7, 'text': 'Descartado'},
            // {'id': 8, 'text': 'Inscrito académico'},
            // {'id': 9, 'text': 'Acreditado en ciclo escolar'},
            {'id': 10, 'text': 'No acreditado en ciclo escolar'},
            {'id': 11, 'text': 'Baja definitiva voluntaria'},
            {'id': 12, 'text': 'Baja definitiva por conducta'},
            // {'id': 13, 'text': 'Baja temporal voluntaria'},
            {'id': 14, 'text': 'Suspensión por morosidad'},
            {'id': 15, 'text': 'Bloqueo para inscripción'},
            {'id': 16, 'text': 'Reactivación'}
        ],
        estatuId: (new Date()).getTime(),
        bloqueo_boleta_por: '',
        cantidad_motivo: '',
        comentario:'',
        errorFields: [],
        congelar_cargos_en_tiempo: ''
    }),
    computed: {
      messageClass () {
        return {
          'md-invalid': this.hasMessages
        }
      }
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await alumno.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },  
        async getCicloEscolar() {
            this.cicloEscolar = ''
            this.loadingCiclo = true
            const { data: response } = await alumno.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingCiclo = false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.fecha) {
                this.errorFields.push('fecha')
            }
            if (!this.estatu) {
                this.errorFields.push('estatu')
            }
            if(([11, 12]).includes(this.estatu)){
                if (!this.bloqueo_boleta_por) {
                    this.errorFields.push('bloqueo_boleta_por')
                }
                if(this.bloqueo_boleta_por == "cartera_vencida"){
                    if (!this.cantidad_motivo) {
                        this.errorFields.push('cantidad_motivo')
                    }
                }
                if (!this.congelar_cargos_en_tiempo) {
                    this.errorFields.push('congelar_cargos_en_tiempo')
                }
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postBajasSuspenciones(){
            if(this.sanityForm()){
            const loading = this.$vs.loading()
                try{
                    const formaData = new FormData();
                    formaData.append('_method', 'PATCH')
                    formaData.append("persona_id", this.general.datos.id)
                    formaData.append("institucion_id", this.institucion)
                    formaData.append("ciclo_escolar_id", this.cicloEscolar)
                    formaData.append("fecha_baja", this.fecha)
                    formaData.append("motivo_id", this.estatu)
                    formaData.append("comentario", this.comentario)
                    formaData.append("bloqueo_boleta_por", this.bloqueo_boleta_por)
                    formaData.append("cantidad_motivo", this.cantidad_motivo)
                    formaData.append("congelar_cargos_en_tiempo", this.congelar_cargos_en_tiempo == 'mantener' ? false : true)
                    
                    const {data: response} = await alumno.postBajasSuspenciones(this.general.datos.persona_id, formaData)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                    })
                    loading.close()
                    this.$emit('refreshComponent', this.general.datos.persona_id)
                }catch(error){
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                    })
                    loading.close()
                }
            }
        },
        closeModal(){
            this.institucion = ''
            this.cicloEscolar = '',
            this.fecha = ''
            this.estatu = ''
            this.bloqueo_boleta_por = ''
            this.congelar_cargos_en_tiempo = ''
            this.comentario = ''
        }
    },
    watch:{
        value (val) {
            this.active = val
        },       
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        institucion(){
            this.getCicloEscolar()
        },
        motivo(){
            if(([11, 12]).includes(this.motivo)){
                this.bloqueo_boleta_por = ''
                this.congelar_cargos_en_tiempo = ''
            }
        }
    }
}
  </script>

<style lang="scss" scoped>
  .motivoClass{
    background: #E9F7EF;
    border: 1px solid #D4EFDF;
    padding: 0.5rem;
  }
</style>
        